import { orderBy } from 'lodash';

import { type Board, SortDirection, type SubnavBoardSort } from '@air/api/types';

export const getOrderedBoards = (
  flattenedBoards: Board[],
  boardSort: SubnavBoardSort = { name: '', direction: SortDirection.asc },
) => {
  switch (boardSort.name) {
    case 'name':
      return {
        orderedBoards: orderBy(flattenedBoards, (board) => board.title.toLowerCase(), [boardSort.direction]),
      };
    case 'dateCreated':
      return {
        orderedBoards: orderBy(flattenedBoards, ['createdAt'], [boardSort.direction]),
      };
    case 'customSort':
      // Backend returns boards in custom-sort order; trust the array.
      return { orderedBoards: flattenedBoards };
    default:
      return { orderedBoards: flattenedBoards };
  }
};
